'use strict'
//Backend
let hostApi = 'calper.iaas.ull.es';
let portApi = 443;
let hostPortApi = hostApi + ":" + portApi;
let version = 'v1/';
let group = 'group';
let process = 'process';
let partialUrl = 'https://' + hostPortApi + "/api/" + version;

//Fronted
let hostFront = 'calper.iaas.ull.es'
let portFront = 443

module.exports = {
    partialUrl,
    group,
    process,
    hostFront,
    portFront
}



//////////////////
// WEBPACK FOOTER
// ./config/conf.env.js
// module id = R5VB
// module chunks = 1